import PaymentNonceDebugOverride from 'components/PaymentNonceDebugOverride';
import React from 'react';
import PropTypes from 'prop-types';
import BraintreeDropIn from 'braintree-web-drop-in-react';
import ReCAPTCHA from 'react-google-recaptcha';

import MediaXlUp from 'components/Responsive/MediaXlUp';
import MediaLgDown from 'components/Responsive/MediaLgDown';

import getDefaultPayPalOptions from 'components/Payment/getDefaultPayPalOptions';

import CurrencySelector from '../CurrencySelector';
import CompanyDetails from './CompanyDetails';
import Packages from './Packages';
import SubmitButton from './SubmitButton';
import VatToggle from './VatToggle';

export default class BraintreeViewComponent extends React.Component {
  state = {
    isReCaptchaValid: false,
  };

  handleReCaptchaChange = (recaptchaResponse) => {
    const { onReCaptchaChange } = this.props;
    this.setState({ isReCaptchaValid: true });
    onReCaptchaChange(recaptchaResponse);
  };

  render() {
    const {
      clientRequestToken,
      currencyCode,
      isBreakdownVisible,
      isPurchasing,
      isSelectingCurrency,
      isWaitingForInstance,
      message,
      onInstance,
      onSelectCurrency,
      onSelectPackage,
      onSetOverrideNonce,
      onSubmit,
      onTogglePriceBreakdown,
      packages,
      selectedPackage,
    } = this.props;

    const { isReCaptchaValid } = this.state;

    return (
      <div>
        <div className="cf" style={{ marginBottom: 5 }}>
          <label htmlFor="currency" style={{ fontWeight: 'bold' }}>Currency</label>
          <CurrencySelector value={currencyCode} onChange={onSelectCurrency} />
          <div className="cf" style={{ marginTop: 20 }}>
            <form className="nex-form">
              <div className="nex-amount">
                <h2 className="heading heading--2 heading--inverse">Select Fate quantity</h2>
                <ul className="nex-amount__list" id="nex-amount-list">
                  <Packages
                    isBreakdownVisible={isBreakdownVisible}
                    isFetching={isSelectingCurrency}
                    onSelect={onSelectPackage}
                    packages={packages}
                    selectedPackage={selectedPackage}
                  />
                </ul>
                <MediaLgDown>
                  <VatToggle onToggle={onTogglePriceBreakdown} />
                </MediaLgDown>
              </div>
              <div className="payment-information">
                <h2 className="heading heading--2 heading--inverse">Payment information</h2>
                <PaymentNonceDebugOverride onSelect={onSetOverrideNonce} />
                <BraintreeDropIn
                  options={getDefaultPayPalOptions(clientRequestToken)}
                  onInstance={onInstance}
                />
              </div>
              <div className="complete-transaction">
                <h2 className="heading heading--2 heading--inverse">Complete transaction</h2>
                <p>
                  Please ensure you have filled in all the fields correctly,
                  {' '}
                  then click the button below to complete the transaction.
                </p>
                <div className="braintree-view__button-container">
                  <div style={{ display: 'flex', textAlign: 'center' }}>
                    <ReCAPTCHA
                      sitekey="6Ldu784UAAAAAI2pquK8B8q4lgT6vXY-Dpa8mu4S"
                      onChange={this.handleReCaptchaChange}
                    />
                  </div>
                  <SubmitButton
                    isPurchasing={isPurchasing}
                    isWaitingForReCaptcha={!isReCaptchaValid}
                    isWaitingForInstance={isWaitingForInstance}
                    onClick={onSubmit}
                    selectedPackage={selectedPackage}
                  />
                  {message && <p className="form__error" style={{ paddingTop: 10 }}>{message}</p>}
                </div>
              </div>
            </form>
            <CompanyDetails />
          </div>
        </div>
        <MediaXlUp>
          <VatToggle onToggle={onTogglePriceBreakdown} />
        </MediaXlUp>
      </div>
    );
  }
}

BraintreeViewComponent.propTypes = {
  clientRequestToken: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  isBreakdownVisible: PropTypes.bool.isRequired,
  isPurchasing: PropTypes.bool.isRequired,
  isSelectingCurrency: PropTypes.bool.isRequired,
  isWaitingForInstance: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onInstance: PropTypes.func.isRequired,
  onReCaptchaChange: PropTypes.func.isRequired,
  onSelectCurrency: PropTypes.func.isRequired,
  onSelectPackage: PropTypes.func.isRequired,
  onSetOverrideNonce: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onTogglePriceBreakdown: PropTypes.func.isRequired,
  packages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedPackage: PropTypes.shape({
    currencyAmount: PropTypes.number.isRequired,
    dollarPrice: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired,
    currency: PropTypes.shape({
      code: PropTypes.string.isRequired,
      dollarValue: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      sign: PropTypes.string.isRequired,
    }).isRequired,
  }),
};

BraintreeViewComponent.defaultProps = {
  selectedPackage: undefined,
};